import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiDelMethod } from 'src/app/api/api-methods.del';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedDeliveryI } from '../../api/shared-delivery/shared-delivery.result.int';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { spxToasterActions, SpxToasterAutoCloseSpeedEnum } from '@softpak/components/spx-toaster';
import { TranslateService } from '@ngx-translate/core';
import * as actions from './shared-delivery.actions';
import * as i18nInterface from 'src/app/shared/_config/i18n/i18n-interface';

@Injectable()
export class SharedDeliveryEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);
    private readonly translateService = inject(TranslateService);


    load$ = createEffect(() =>
        this.actions$.pipe(ofType(actions.load),
            mergeMap((params) => this.sharedGenericService.invoke(ApiDelMethod.sharedDelivery, params.data).pipe(
                map((data: SharedDeliveryI) =>
                    actions.received({
                        data: data ? data : undefined,
                        pageType: params.pageType,
                    })),
                catchError((error: SharedErrorObjectI) => [
                    actions.error({
                        messageText: error.message,
                        pageType: params.pageType,
                    }),
                ])
            ))
        ));

    onError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(action => [
            spxToasterActions.createError({
                autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
                messageText: action.messageText,
                title: this.translateService.instant(i18nInterface.textDelivery),
            }),
        ]))
    );
}
